const getParamName = (flow) => `is${flow}DrawerOpen`;
export const SET_DRAWER_STATE = 'SET_DRAWER_STATE';

export const DRAWER_PARAM_TEMPLATE = getParamName('Template');

export const OFFER_FILTERS_DRAWER = getParamName('OfferFilters');
